import { Divider } from '@mantine/core';

import classes from './index.module.css';

const FooterDivider = () => {
    return <Divider className={classes.divider} />
}

export default FooterDivider;